import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import jwt_decode from 'jwt-decode';
import styles from './LoginPage.module.css';
import Button from '../../components/Button';
import InputField from '../../components/InputField';
import LoginCard from '../../components/LoginCard';
import LoginHeader from '../../components/LoginHeader';
import FlexBetween from '../../components/utils/FlexBetween';
import server from '../../apis/server';

const LoginPage = () => {
  const { setIsLoggedIn } = useContext(UserContext);

  const [isFetching, setIsFetching] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onFormSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsFetching(true);
      const res = await server.post('/user/login', {
        username,
        password,
      });

      setIsFetching(false);

      localStorage.setItem('token', res.data.token);

      setIsLoggedIn(jwt_decode(res.data.token));
    } catch (err) {
      setIsFetching(false);
    }
  };

  return (
    <div className={styles.page}>
      <LoginCard onSubmit={onFormSubmit}>
        <FlexBetween style={{ marginBottom: '1rem' }}>
          <Link to="/login">
            <LoginHeader text="Log In" active />
          </Link>
          <Link to="/signup">
            <LoginHeader text="Sign Up" />
          </Link>
        </FlexBetween>
        <InputField
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <InputField
          placeholder="Password"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
        />
        <Button text="Log In" type="submit" isFetching={isFetching} />
      </LoginCard>
    </div>
  );
};

export default LoginPage;
